import { Image } from "react-bootstrap";
import FlexBox from "../common/flex-box";
import React from "react";
import SimpleCard from "../common/simple-card";
import { ASSETS } from "assets";

interface AuthenticationFormProps {
  children: React.ReactNode;
  isLoading?: boolean;
  className?: string;
}

const AuthenticationForm: React.FC<AuthenticationFormProps> = ({
  children,
  isLoading,
  className,
}) => {
  return (
    <SimpleCard
      className={`authentication-form shadow ${className}`}
      isLoading={isLoading}
      loadingMessage="Loading..."
    >
      <FlexBox justifyContent="center" className="mb-4">
        <Image src={ASSETS.IMAGES.LOGO_LIGHT} alt="HEAL" className="logo" />
      </FlexBox>
      {children}
    </SimpleCard>
  );
};

export default AuthenticationForm;
